import { COUNTRY_OPTIONS } from '@/_constants/phone_numbers';

export const formatPhoneNumber = (phone?: string | null): string => {
  if (!phone) return '';

  const input = phone.replace(/\D/g, '');
  let formattedInput = '';

  if (input.length > 0) {
    formattedInput += '(' + input.slice(0, 3);
  }

  if (input.length >= 3) {
    formattedInput += ') ';
  }

  if (input.length >= 3) {
    formattedInput += input.slice(3, 6);
  }

  if (input.length > 6) {
    formattedInput += '-' + input.slice(6, 10);
  }

  return formattedInput;
};

export const deformatPhoneNumber = (phone?: string | null): string => {
  // Remove all non-numeric characters
  if (!phone) return '';

  return phone.replace(/\D/g, '');
};

const SORTED_CODES = COUNTRY_OPTIONS.map((o) => o.code).sort(
  (a, b) => b.length - a.length,
);

// Helper to parse a saved phone value of the form "+CC <local>"
export const parseInitialPhone = (
  value: string | undefined,
): { code: string; local: string } => {
  if (!value) return { code: '+1', local: '' };

  const trimmed = value.trim();
  const spaceIdx = trimmed.indexOf(' ');

  if (trimmed.startsWith('+') && spaceIdx > 1) {
    const code = trimmed.slice(0, spaceIdx);
    let localRaw = trimmed.slice(spaceIdx + 1).trim();
    if (code === '+1' && /^1\d{10}$/.test(localRaw.replace(/\D/g, ''))) {
      const onlyDigits = localRaw.replace(/\D/g, '');
      localRaw = onlyDigits.slice(1);
    }
    return { code, local: localRaw };
  }

  if (trimmed.startsWith('+')) {
    const digits = trimmed.replace(/\D/g, '');
    const prefixed = `+${digits}`;
    const match = SORTED_CODES.find((cc) => prefixed.startsWith(cc));
    if (match) {
      const localRaw = prefixed.slice(match.length);
      return { code: match, local: localRaw.replace(/^\+/, '') };
    }
  }
  return { code: '+1', local: trimmed };
};
